export default __webpack_public_path__ + "static/media/new-evaluation-screenshot.42f51073.jpg";